import React from "react";


export default function Rules() {
    return (
        <div className="">
            <div className="rules">
                <h1>How to play</h1>
                <h2>Guess the word in 6 trys</h2>
                <ul>
                    <li>Each guess must be a valid 5 letter word</li>

                    <li>The color of the tiles will change depending on how close you are to guessing the word</li>
                </ul>
            </div>
        </div>
    )
};
